import * as UserActions from '@Actions/user.actions';
import { UserService } from '@Services/user.service';
import { AppState } from '@State/app.state';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  mergeMap,
  of,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userSvc: UserService,
    private store: Store<AppState>
  ) {}

  loadAnagrafica$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadAnagraficaUtente),
      mergeMap(() =>
        this.userSvc.getAnagraficaUtente().pipe(
          map((anagrafica) =>
            UserActions.setAnagraficaUtente({
              anagraficaUtente: anagrafica.user,
            })
          ),
          catchError((error) =>
            of(UserActions.userStateError({ loadError: error }))
          )
        )
      )
    )
  );

  loadLoggedUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadLoggedUserInfo),
      mergeMap(() =>
        this.userSvc.getLoginInfo().pipe(
          tap((loggedInfo) => {
            localStorage.setItem('loginToken', loggedInfo.view.token);
          }),
          map((loggedInfo) =>
            UserActions.setLoggedUserInfo({
              infoUtenteLoggato: loggedInfo.view,
            })
          ),
          catchError((error) =>
            of(UserActions.userStateError({ loadError: error }))
          )
        )
      )
    )
  );

  loadAllUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadAllUserInfo),
      withLatestFrom(this.store.select((state) => state.user)),
      // se userInfo e' gia popolato skippa le chiamate API
      filter(
        ([action, userInfo]) =>
          userInfo.anagraficaUtente.codanaute === -1 &&
          userInfo.infoUtenteLoggato.token === ''
      ),
      switchMap(() =>
        //prima prende le login info per salvare in LS il loginToken
        //necessario per auth getAnagraficaUtente()
        this.userSvc.getLoginInfo().pipe(
          tap((loggedInfo) => {
            localStorage.setItem('loginToken', loggedInfo.view.token);
          }),
          switchMap((loggedInfo) =>
            //poi chiama il servizio per l'anagrafica
            this.userSvc.getAnagraficaUtente().pipe(
              map((anagrafica) => ({
                loggedInfo: loggedInfo.view,
                anagrafica: anagrafica.user,
              }))
            )
          )
        )
      ),
      map(({ loggedInfo, anagrafica }) =>
        UserActions.setAllUserInfo({
          anagraficaUtente: anagrafica,
          infoUtenteLoggato: loggedInfo,
        })
      ),
      tap(() => {
        this.store.dispatch(UserActions.userInfoLoaded({ infoLoaded: true }));
      }),
      catchError((error) =>
        of(UserActions.userStateError({ loadError: error }))
      )
    )
  );
}
